import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'Master industrial hydraulics and pneumatics, from fundamentals to field troubleshooting. 6 professional volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-slate-950 font-sans text-slate-300 antialiased" data-id="element-0" data-mp="nwc5m3lqig1j">
      <MetaPixel data-id="element-1" data-mp="stkjhrzunxwz" />
      <main data-id="element-2" data-mp="st2kinlsz5ld">
        <Hero data-id="element-3" data-mp="swqcvjfihlyi" />
        <LookInsideCarousel data-id="element-4" data-mp="36hwt7ylgu1r" />
        <ProblemSection data-id="element-5" data-mp="35oz0whm5evr" />
        <SystemSection data-id="element-6" data-mp="356wji4cy4fe" />
        <ModulesSection data-id="element-7" data-mp="38kvegdtbvi3" />
        <BonusSection data-id="element-8" data-mp="3ud1gzdqblwcq" />
        <UrgencySection data-id="element-9" data-mp="3udkn7x6lywax" />
        <PricingSection data-id="element-10" data-mp="3uc9k7zkzlskv" />
        <GuaranteeSection data-id="element-11" data-mp="3uf5ixq4nslad" />
        <FAQ data-id="element-12" data-mp="d4e9i476jx1z" />
        <ClosingSection data-id="element-13" data-mp="d4xr1jsx4jfh" />
        <SummaryTable data-id="element-14" data-mp="d45t42bum9m1" />
        <FinalCta data-id="element-15" data-mp="d2l7513lnyzs" />
      </main>
      <Footer data-id="element-16" data-mp="851kbcsu6dw8" />
      <PurchaseNotification data-id="element-17" data-mp="85bc95xfyv4k" />
    </div>;
}